<script lang="ts">
	import * as Accordion from '$lib/components/ui/accordion/index.js';
	import type { ListingSeoIntro } from '$lib/content/listing-seo-faqs';
	import type { FaqSchemaItem } from '$lib/utils/marketing-seo';
	import { localizeHref } from '@/paraglide/runtime';

	let {
		intro,
		faqs = []
	}: {
		intro: ListingSeoIntro;
		faqs?: FaqSchemaItem[];
	} = $props();
</script>

<section aria-labelledby="listing-seo-heading" class="border-t border-gray-200 py-6 md:py-12">
	<div class="mx-auto max-w-3xl space-y-6">
		<div class="space-y-3">
			<h2
				id="listing-seo-heading"
				class="text-balance text-xl font-semibold tracking-tight text-gray-900 md:text-2xl"
			>
				{intro.heading}
			</h2>
			{#each intro.paragraphs as paragraph, i (i)}
				<p class="text-pretty text-sm leading-relaxed text-gray-700 md:text-base">{paragraph}</p>
			{/each}
		</div>

		{#if intro.hubLinks.length > 0}
			<nav aria-label="Enlaces relacionados" class="flex flex-wrap gap-2">
				{#each intro.hubLinks as link (link.href)}
					<a
						href={localizeHref(link.href)}
						class="rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 transition-colors hover:border-gray-300 hover:bg-gray-50 md:text-sm"
					>
						{link.label}
					</a>
				{/each}
			</nav>
		{/if}

		{#if faqs.length > 0}
			<div class="space-y-3">
				<h3 class="text-lg font-medium text-gray-900">Preguntas frecuentes</h3>
				<Accordion.Root
					type="single"
					class="w-full rounded-lg border border-gray-200 bg-white px-4"
				>
					{#each faqs as faq, index (faq.question)}
						<Accordion.Item value={`listing-faq-${index}`}>
							<Accordion.Trigger class="text-left text-sm md:text-base"
								>{faq.question}</Accordion.Trigger
							>
							<Accordion.Content class="text-muted-foreground text-sm leading-relaxed md:text-base">
								{faq.answer}
							</Accordion.Content>
						</Accordion.Item>
					{/each}
				</Accordion.Root>
			</div>
		{/if}
	</div>
</section>
